import React from 'react';
import { Grid } from 'semantic-ui-react';
import { connect, ConnectedProps } from 'react-redux';
import { IState } from '@pvolve/sdk/src/redux/selectors';

import Selectors from 'src/state/root-selectors';
import EmailForm from 'src/components/auth/EmailForm';
import SocialButton from 'src/components/auth/SocialButton';
import SEO from 'src/components/SEO';
import withLocation from 'src/components/withLocation';
import { Icon, SquareCloseButton } from 'src/components/shared';
import { SUI_GRID_CENTERED } from 'src/utils/semantic-utils';

import * as authStyles from 'src/styles/auth.module.scss';

const connector = connect((state: IState) => ({
    activationCodeProduct: Selectors.subscriptions.setActivationCode.product(state),
}));

interface ContinueAuthPageProps extends ConnectedProps<typeof connector> {
    location: {
        state: {
            activationCode: string;
            checkout: boolean;
        };
    };
}

export const ContinueAuthPage = ({ activationCodeProduct, location }: ContinueAuthPageProps) => {
    const activationCode = location?.state?.activationCode;

    const checkout = location?.state?.checkout;

    const { widths } = SUI_GRID_CENTERED;

    return (
        <div className={authStyles.continueWrapper}>
            <SEO title="P.Volve Continue to Login or Signup" />
            <SquareCloseButton />
            <div className={authStyles.socialButtonsWrapper}>
                <Grid container centered>
                    {activationCodeProduct && activationCode && (
                        <Grid.Row>
                            <Grid.Column
                                mobile={widths.mobile}
                                tablet={widths.tablet}
                                computer={widths.computer}
                            >
                                <div className={`${authStyles.confirmationMsg}`}>
                                    <Icon name="pv-checkmark-circle" color="light-lime" size={10} />
                                    <p className="color-pv-light-lime p3">
                                        Code valid for {activationCodeProduct.name} streaming
                                        subscription. Create your account below to get started.
                                    </p>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    )}
                    {checkout && (
                        <p className="color-pv-white p3">
                            Log in or create your account to complete your order.
                        </p>
                    )}
                    <Grid.Row>
                        <Grid.Column
                            mobile={widths.mobile}
                            tablet={widths.tablet}
                            computer={widths.computer}
                        >
                            <SocialButton provider="apple" label="Continue with Apple" />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column
                            mobile={widths.mobile}
                            tablet={widths.tablet}
                            computer={widths.computer}
                        >
                            <SocialButton provider="google" label="Continue with Google" />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column
                            mobile={widths.mobile}
                            tablet={widths.tablet}
                            computer={widths.computer}
                        >
                            <SocialButton provider="facebook" label="Continue with Facebook" />
                        </Grid.Column>
                    </Grid.Row>
                    <p className="color-pv-white tiny">
                        We won't post anything without your permission
                    </p>
                    <p className={authStyles.divider}>OR</p>
                </Grid>
            </div>
            <EmailForm />
        </div>
    );
};

export default connector(withLocation(ContinueAuthPage));
